import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private _progress = signal<number>(0);
    private _isLoading = signal<boolean>(false);

    progress = this._progress.asReadonly();
    isLoading = this._isLoading.asReadonly();

    private interval: any;

    start() {
        this._isLoading.set(true);
        this._progress.set(0);
        this.startSimulation();
    }

    set(value: number) {
        this._progress.set(value);
    }

    complete() {
        this.stopSimulation();
        this._progress.set(100);
        setTimeout(() => {
            this._isLoading.set(false);
            this._progress.set(0);
        }, 300);
    }

    private startSimulation() {
        this.stopSimulation();
        this.interval = setInterval(() => {
            const current = this._progress();
            if (current < 30) {
                this._progress.set(current + Math.random() * 5);
            } else if (current < 70) {
                this._progress.set(current + Math.random() * 2);
            } else if (current < 95) {
                this._progress.set(current + Math.random() * 0.5);
            }
        }, 200);
    }

    private stopSimulation() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
